// extracted by mini-css-extract-plugin
module.exports = {"field-text":"LinksList_field-text__emeQ0","bold":"LinksList_bold__3v3hW"};